import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

// import * as firebase from 'firebase';

const prodConfig = {
    apiKey: "AIzaSyD7NOpKzO5CCfyLOrET4WWQ0i2ibwKEr18",
    authDomain: "pixsells-new-internet-a33b4.firebaseapp.com",
    databaseURL: "https://pixsells-new-internet-a33b4.firebaseio.com",
    projectId: "pixsells-new-internet-a33b4",
    storageBucket: "pixsells-new-internet-a33b4.appspot.com",
    messagingSenderId: "391052048297"
  };

const devConfig = {
    apiKey: "AIzaSyD6wW_84-sOX0mzkRAG1rqNEAeSNxa7UWo",
    authDomain: "pixsells-new-internet.firebaseapp.com",
    databaseURL: "https://pixsells-new-internet.firebaseio.com",
    projectId: "pixsells-new-internet",
    storageBucket: "pixsells-new-internet.appspot.com",
    messagingSenderId: "920325440049"
  };

  const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

  if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js